import styled from 'styled-components';
import palette from '../../lib/styles/palette';
import { Link } from 'react-router-dom';
import Button from '../common/Button';
import { useSelector } from 'react-redux';

const ProjectBrief = ({ project }) => {
    // ProjectBrief 라는 이름이 나을 듯
    const { title, body, user, publishedDate, tags, _id } = project;
    const { comment, contractDate, contact } = body;

    return (
        <ProjectBriefBlock>
            <h3>
                <Link to={`/projects/${_id}`}>{title}</Link>
            </h3>{' '}
            {/* 프로젝트 _id */}
            <MainInfo>
                <span>{comment}</span>
                <span>계약일 : {contractDate}</span>
                <span>{contact}</span>
            </MainInfo>
            <SubInfo>
                <span>
                    <Link to={`/projects/list/${user.username}`}>
                        <b className="user-name">{user.username}</b>
                    </Link>
                </span>
                <span>{new Date(publishedDate).toLocaleDateString()}</span>
            </SubInfo>
            <Tags>
                {tags.map((tag, index) => (
                    <Link to={`?tag=${tag}`} key={index}>
                        <div className="tag">#{tag}</div>
                    </Link>
                ))}
            </Tags>
        </ProjectBriefBlock>
    );
};

const ProjectList = ({ loading, error, projects, user }) => {
    const language = useSelector(state => state.language.language);
    const isKR = language === 'KR' ? true : false;
    const isJP = language === 'JP' ? true : false;
    const isEN = language === 'EN' ? true : false;

    // 에러 발생 시
    if (error) {
        return <ProjectListBlock>에러가 발생했습니다.</ProjectListBlock>;
    }


    return (
        <ProjectListBlock>
            {/* 새 프로젝트 작성하기 버튼을 여기에 */}
            {user && (
                <WriteProjectButtonWrapper>
                    <Button cyan to="/write/project">
                        {isKR && '새로운 프로젝트'}
                        {isJP && '新しいプロジェクトの作成'}
                        {isEN && 'New Project'}
                    </Button>
                </WriteProjectButtonWrapper>
            )}
            {/* 로딩 중이 아니고, 컨베이어 배열이 존재할 때만 보여 줌 */}
            {!loading && projects && (
                <div>
                    {projects.map((project, index) => (
                        <ProjectBrief project={project} key={index} />
                    ))}
                </div>
            )}
            <WriteProjectButtonWrapper>
                <Button cyan to="/projects">
                    {isKR && '전체 프로젝트 보기'}
                    {isJP && 'すべてのプロジェクトを見る'}
                    {isEN && 'List all Project'}
                </Button>
            </WriteProjectButtonWrapper>
        </ProjectListBlock>
    );
};

export default ProjectList;

const ProjectListBlock = styled.div`
    // margin-top: 3rem;
    padding-left: 1rem;
    padding-right: 1rem;

    width: 100%;
    max-width: 1280px;
    margin: 0 auto;

    box-sizing: border-box;
`;

const WriteProjectButtonWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-bottom: 3rem;
`;

const ProjectBriefBlock = styled.div`
    padding-top: 2rem;
    padding-bottom: 2rem;
    &:first-child {
        padding-top: 0;
    }
    & + & {
        border-top: 1px solid ${palette.gray[2]};
    }
    h2 {
        font-size: 1.25rem;
        margin-bottom: 0;
        margin-top: 0;

        &:hover {
            color: ${palette.cyan[3]}; // 작동하지 않음. 이유 모르겠음. '24.1/6
        }
    }
`;

const MainInfo = styled.div`
    color: ${palette.gray[6]};

    span + span::before {
        content: '/';
        padding-left: 0.5rem;
        padding-right: 0.5rem;
    }
`;

const SubInfo = styled.div`
    margin-top: 1rem;
    color: ${palette.gray[6]};
    /* span 사이에 가운뎃 점 보여주기 */
    span + span::before {
        color: ${palette.gray[6]};
        padding-left: 0.25rem;
        padding-right: 0.25rem;
        content: '\\B7'; /* 가운뎃점 문자 */
    }
    .user-name {
        color: ${palette.gray[6]};
    }
`;

const Tags = styled.div`
    margin-top: 0.5rem;
    // display: flex;   // 굳이 flex를 쓰지 않고도 inlin-block으로 간단히 해결할 수 있다.
    .tag {
        display: inline-block;
        color: ${palette.cyan[7]};
        text-decoration: none;
        margin-right: 0.5rem;
        &:hover {
            color: ${palette.cyan[5]};
        }
    }
`;
